import { useState, type FormEvent } from "react";
import { useAuth } from "@/platform/client";
import { ApiError } from "@/platform/client";
import { WaypointLogo } from "@/platform/ui";
import { Button, Field, inputClass } from "@/platform/ui";

export function LoginPage() {
  const { login } = useAuth();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(password);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center gap-3 text-center">
          <WaypointLogo markClassName="h-12 w-12" />
        </div>

        <form
          onSubmit={onSubmit}
          className="rounded-2xl border border-line bg-surface p-6 shadow-2xl"
        >
          <Field label="Password">
            <input
              type="password"
              autoFocus
              className={inputClass}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
            />
          </Field>
          {error && <p className="mt-3 text-sm text-negative">{error}</p>}
          <Button type="submit" variant="primary" className="mt-5 w-full" disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
